<template>
  <div class="search_form_container">
    <div class="search_form">
      <el-form label-position="right" label-width="auto" ref="searchForm" :model="formModel" class=""
        :disabled="disabled" @submit.prevent>
        <el-row>
          <transition-group name="slide-fade">
            <slot name="layout" :formModel="formModel" :formItemFn="formItemFn">
            </slot>
          </transition-group>
        </el-row>
      </el-form>
    </div>
    <div class="search_btn_container" :class="[searchBtnCenter?'items-center':'items-start']" v-if="btnShow">
      <div class="search_btn">
        <slot name="searchBtn" :scope="{ disabled, search, reset }">
          <!-- 默认显示内容 -->
          <el-button type="primary" @click="search" :disabled="disabled">查询</el-button>
          <el-button v-if="!hideReset" :icon="Refresh" @click="reset" :disabled="disabled">重置</el-button>
        </slot>
      </div>
    </div>
  </div>
</template>
<script setup>
import { computed, ref, reactive, onBeforeMount } from "vue";
import {
  ArrowUpBold,
  ArrowDownBold,
  Search,
  Refresh,
} from "@element-plus/icons-vue";

import useSearchForm from "./index.js";
import { dayjs } from "element-plus";
dayjs.en.weekStart = 1;
const props = defineProps({
  formData: {
    type: Array,
    default: () => [],
  },
  page: {
    type: Object,
    require: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  searchBtnCenter: {
    type: Boolean,
    default: false,
  },
  hideReset: {
    type: Boolean,
    default: false,
  },
  data: {
    type: Object,
  },
  noreset: {
    type: Array,
    default: () => [],
  },
  allowEmpty: {
    type: Array,
    default: () => [],
  },
  btnShow: {
    type: Boolean,
    default: true,
  },
  isShowClearable: {
    type: Boolean,
    default: true,
  },
  //  defaultTimeFieldNames: {
  // 	 type: Array,
  // 	 default: () => [],
  //  },
});

const emit = defineEmits([
  "formChange",
  "searchCallback",
  "resetCallback",
  "update:page",
  "update:data",
]);
const {
  formModel,
  formItemFn,
  search,
  reset,
} = useSearchForm(props, emit);
</script>
<style lang="scss" scoped>
.search_form_container {
  display: flex;

  .search_form {
    flex: 1;

    :deep(.search_form_col) {
      label {
        font-weight: unset;
      }
    }

    .slide-fade-enter-active,
    .slide-fade-leave-active {
      transition: all 0.1s ease-in-out;
    }

    .slide-fade-enter,
    .slide-fade-leave-to {
      opacity: 0;
    }

    .search_form_col {
      padding-right: 20px;
    }
  }

  .search_btn_container {
    display: flex;
    // margin-left: 50px;
    // flex: 1;
    &.items-center{
      align-items: center;
    }
    &.items-start{
      align-items: start;
    }
    .search_btn {
      align-items: center;
      display: flex;

      .el-button+.el-button {
        margin-left: 10px;
      }

      .search_btn_expanded {
        cursor: pointer;
        user-select: none;
        margin-left: 15px;
        font-size: 14px;
        width: 50px;
      }
    }
  }
}
</style>
